import { SectionHeading, SectionLabel } from "./Section";

const steps = [
    {
        label: "Team Data",
        detail: "Sales, Finance, HR, Ops, Marketing.",
        icon: (
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
                <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
        ),
    },
    {
        label: "AI Agents",
        detail: "10 domain agents analyze context.",
        icon: (
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
                <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
        ),
    },
    {
        label: "Decision Card",
        detail: "Real-time approve / simulate / reject.",
        icon: (
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
                <rect x="3" y="5" width="18" height="14" rx="3" stroke="currentColor" strokeWidth="1.6" />
                <path d="M7 10h10M7 14h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
        ),
    },
    {
        label: "CEO Action",
        detail: "Approved. Executed. Tracked.",
        icon: (
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none">
                <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
    },
];

export default function Solution() {
    return (
        <section id="solution" data-testid="solution-section" className="relative py-28 sm:py-36">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="reveal max-w-3xl">
                    <SectionLabel num="02">The Solution</SectionLabel>
                    <SectionHeading className="mt-6">
                        One conversation that understands your{" "}
                        <span className="italic text-neutral-700 font-normal">
                            entire business
                        </span>
                        .
                    </SectionHeading>
                    <p className="mt-6 text-[15px] sm:text-lg text-neutral-600 leading-relaxed max-w-2xl">
                        CEO’s GPT converts every department update into
                        real-time AI decision cards inside one intelligent
                        command interface.
                    </p>
                </div>

                {/* Flow */}
                <div
                    data-testid="solution-flow-diagram"
                    className="reveal relative mt-16 sm:mt-20"
                >
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-2">
                        {steps.map((s, i) => (
                            <div key={s.label} className="relative">
                                <div className="glass rounded-3xl p-6 sm:p-7 h-full">
                                    <div className="flex items-center gap-3">
                                        <span className="inline-flex items-center justify-center h-9 w-9 rounded-2xl bg-white border border-black/5 text-neutral-700">
                                            {s.icon}
                                        </span>
                                        <span className="font-mono-alt text-[11px] text-neutral-400">
                                            0{i + 1}
                                        </span>
                                    </div>
                                    <div className="mt-6 font-display text-xl sm:text-2xl font-medium text-black">
                                        {s.label}
                                    </div>
                                    <p className="mt-1.5 text-[13px] text-neutral-500 leading-relaxed">
                                        {s.detail}
                                    </p>
                                </div>

                                {/* Connector */}
                                {i < steps.length - 1 && (
                                    <>
                                        <div className="hidden md:flex absolute top-1/2 -right-3 -translate-y-1/2 z-10 items-center justify-center h-6 w-6 rounded-full bg-white border border-black/5 text-violet-500">
                                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </div>
                                        <div className="hidden md:block absolute top-1/2 left-full h-px -translate-y-1/2 w-6 pointer-events-none overflow-hidden">
                                            <div className="h-px w-full bg-gradient-to-r from-violet-400/60 to-violet-400/0" />
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
